import { useEffect, useRef } from 'react';
import styles from './PresentationDetailModal.module.scss';
import closeBack from '@assets/img/closeBack.svg';
import fileIcon from '@assets/img/AdminPanel/fileSolid.svg';
import fileMissingIcon from '@assets/img/AdminPanel/fileDownloadOutline.svg';
import gsap from 'gsap';
import { server } from '../../apirequests/apirequests';

function PresentationDetailModal({ data, onClose, onDownload }) {
  const refForm = useRef(null);
  const refBackdrop = useRef(null);
  const presentation = data?.presentation?.[0];

  useEffect(() => {
    const element = refForm.current;
    const backdrop = refBackdrop.current;

    gsap.fromTo(backdrop, { opacity: 0 }, { opacity: 1, duration: 0.4, ease: 'power2.out' });
    gsap.fromTo(
      element,
      { y: 100, opacity: 0 },
      { y: 0, opacity: 1, duration: 0.4, ease: 'power2.out' },
    );

    return () => {
      gsap.to(backdrop, { opacity: 0, duration: 0.4, ease: 'power2.in' });
      gsap.to(element, { y: 100, opacity: 0, duration: 0.4, ease: 'power2.in' });
    };
  }, []);

  useEffect(() => {
    const handleClickOutside = event => {
      if (refForm.current && !refForm.current.contains(event.target)) {
        onClose();
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [onClose]);

  return (
    <section className={styles.PresentationDetailModal} ref={refBackdrop}>
      <div className={styles.inner} ref={refForm}>
        <div className={styles.head}>
          <div className={styles.fio}>
            {(data?.fio || []).map((name, index) => (
              <span key={index}>
                {name}
                <br />
              </span>
            ))}
          </div>
          <button type="button" onClick={onClose}>
            <img src={closeBack} alt="Close" />
          </button>
        </div>

        <div className={styles.field}>
          <p className={styles.label}>Организация</p>
          <p className={styles.value}>{data?.organization || '—'}</p>
        </div>
        <div className={styles.field}>
          <p className={styles.label}>Направление</p>
          <p className={styles.value}>{data?.direction || '—'}</p>
        </div>
        <div className={styles.field}>
          <p className={styles.label}>Доклад</p>
          <p className={styles.value}>{data?.name || '—'}</p>
        </div>
        <div className={styles.field}>
          <p className={styles.label}>Презентация</p>
          {presentation?.url ? (
            <div className={styles.presentationAvailable}>
              <img src={fileIcon} alt="" />
              <a
                href={`${server}/${presentation.url}`}
                onClick={e => {
                  e.preventDefault();
                  onDownload?.(presentation.url, presentation.name || 'presentation');
                }}
              >
                {presentation.name || 'Презентация'}
              </a>
            </div>
          ) : (
            <div className={styles.presentationMissing}>
              <img src={fileMissingIcon} alt="" />
              <span>Отсутствует</span>
            </div>
          )}
        </div>
      </div>
    </section>
  );
}

export default PresentationDetailModal;
